import React from 'react';
import { PageHeroBreadcrumb } from '../components/layout/PageHeroBreadcrumb';
import { PharmacistConsultation } from '../components/product/PharmacistConsultation';
export function PharmacistConsultationPage() {
  return <main className="flex-grow bg-gray-50 pt-[var(--header-height-mobile)] md:pt-[var(--header-height-desktop)]" data-id="element-7208" data-mp="1rb5bd7f2gfkj">
      <PageHeroBreadcrumb breadcrumbs={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'Pharmacist Consultation'
    }]} title="Pharmacist Consultation" description="Consult a pharmacist directly to answer your inquiries and get help choosing the right product." data-id="element-7209" data-mp="1mdvp20mz4k0x" />
      <div className="container mx-auto px-4 py-8" data-id="element-7210" data-mp="13lt4ie77ojle">
        <div className="max-w-3xl mx-auto" data-id="element-7211" data-mp="13p8kdj8plwnv">
          <PharmacistConsultation data-id="element-7212" data-mp="2j2l7bs2ijenf" />
        </div>
      </div>
    </main>;
}